import React, { useCallback, useState } from 'react';
import CurrencyConversionSettingsPanelView from '../view/CurrencyConversionSettingsPanelView';
import { UPDATE_CURRENCY_CONVERSION_FIELD } from '../../../store/modules/state/formBuilder';
import {
  currencies,
  defaultCurrency,
  getCurrencySelectOptions,
  getCurrencyCodeByName
} from '../../../internal-components/form-builder/currencies';
import useGlobalVariables from '../../../hooks/useGlobalVariables';

const CurrencyConversionSettingsPanelEngine = props => {
  const { setIsLoading } = useGlobalVariables();
  const {
    autosaveField,
    options = [],
    showCurrencyConversionDialog,
    setShowCurrencyConversionDialog
  } = props;
  const [currency, setCurrency] = useState(options[0] || defaultCurrency);
  const currencyOptions = getCurrencySelectOptions();
  const clickedSave = () => {
    setIsLoading(true);
    const value = currency;
    // persist
    autosaveField(UPDATE_CURRENCY_CONVERSION_FIELD, {
      converted_title: `Converted value in ${currencies[value].symbol} (${currencies[value].name})`,
      field: {
        options: [value]
      },
      options: [value],
      isAdminOnly: props.isAdminOnly
    });

    setTimeout(() => {
      setShowCurrencyConversionDialog(false);
      setIsLoading(false);
    }, 1000);
  };

  const onCurrencyChanged = value => {
    setCurrency(getCurrencyCodeByName(value));
  };

  const asyncCurrencyOptions = searchValue => {
    return new Promise((resolve, reject) => {
      try {
        if (searchValue) {
          return resolve(
            currencyOptions.filter(one =>
              one.displayString
                .toLocaleLowerCase()
                .includes(searchValue.toLocaleLowerCase())
            )
          );
        }
        return resolve(currencyOptions);
      } catch (e) {
        reject(e);
      }
    });
  };

  const openMenuOptionParser = useCallback(
    optionObject => {
      const matchingCurrency = currencyOptions.find(
        one => one.value === optionObject.value
      );
      return `${matchingCurrency.displayString}`;
    },
    [currencyOptions]
  );

  const getPlaceholderValue = useCallback(() => {
    let result, match, currencyName;
    result = 'Currency';
    if (!currency) {
      return result;
    }
    currencyName = currencies[currency].name;
    match = currencyOptions.find(one => one.name === currencyName);
    if (match) {
      result = match.displayString;
    }
    return result;
  }, [currencyOptions, currency]);

  const placeholder = getPlaceholderValue();

  const viewProps = {
    asyncCurrencyOptions,
    showCurrencyConversionDialog,
    setShowCurrencyConversionDialog,
    clickedSave,
    currency,
    onCurrencyChanged,
    openMenuOptionParser,
    placeholder
  };

  return <CurrencyConversionSettingsPanelView {...viewProps} />;
};

export default CurrencyConversionSettingsPanelEngine;
